export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        padding: "0px 15px 10px 15px",
        marginBottom: "10px",
        overflow: "hidden",
        maxWidth: "100%"
    },
    cardContainer: {
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        maxWidth: "100%"
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    mainHeadingText: {
        fontSize: theme.typography.h4,
        fontWeight: 600
    },
    approveBtn: {
        backgroundColor: '#0B51C5',
        color: '#FFFFFF',
        borderRadius: '20px',
        width: '80px',
        height: '30px',
        textTransform: 'none',
        fontSise: '14px',
        fontWeight: '600'
    },
    navigationBtn: {
        "& .MuiPaginationItem-root": {
            borderRadius: "50%",
            border: "1px solid #0B51C5",
            color: "#0B51C5",
            width: "24px",
            height: "24px",
            minWidth: "24px",
            fontSize: "0.75rem",
            lineHeight: "24px",
            padding: 0,
        },
        "& .Mui-selected": {
            backgroundColor: "#0B51C5",
            color: "#fff",
            border: "1px solid #0B51C5",
            "&:hover": {
                backgroundColor: "#0B51C5",
            },
        },
    },
    chatbotBtn: {
        width: 50,
        height: 50,
        minWidth: 50,
        borderRadius: "50%",
        boxShadow: "0 16px 32px rgba(0,0,0,0.35)",
        background: "#DFDFDF",
        color: "#000000",
        fontSize: 18,
        fontWeight: 700,
        textTransform: "none",
        transition: "all .25s ease",
        "&:hover": {
            transform: "translateY(-3px) scale(1.05)",
            boxShadow: "0 16px 32px rgba(0,0,0,0.35)",
            background: "#DFDFDF",
        }
    }
})